import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
  overflow: hidden;
  @media (max-width: 1200px) {
    flex-direction: column;
    height: auto;
  }
`;

export const Section = styled.section`
  //background: ${(props) => props.theme.configs.cor_fundo};
  padding-left: 5px;
  width: 60.41%;
  height: 100%;
  display: flex;
  padding-top: calc(0.245 * 100vh);
  align-items: flex-start;
  flex-direction: column;
  padding-left: 10.7rem;
  padding-bottom: 7%;
  @media (max-width: 1200px) {
    padding-left: 0;
  }

  p {
    font-family: "Galano";
    line-height: 2.1rem;
    font-size: calc(1.6rem * var(--font-size-scale));
    font-weight: 600;
    font-style: normal;
    //color: ${(props) => props.theme.configs.cor_texto};
    margin-bottom: 2.5rem;
    margin-right: 7.9rem;
    @media (max-width: 1200px) {
      color: #565656;
      text-align: center;
      margin: 0 0 2rem 0;
      line-height: 2.5rem;
      font-size: calc(2rem * var(--font-size-scale));
    }

    & + p {
      //color: ${(props) => props.theme.configs.cor_texto};
      font-family: "Galano";
      line-height: 2.2rem;
      font-size: calc(1.7rem * var(--font-size-scale));
      font-weight: 300;
      font-style: normal;
      @media (max-width: 1200px) {
        color: #565656;
        margin: 0 0 6rem 0;
        width: 100%;
      }
    }
  }

  @media (max-width: 1200px) {
    width: 80%;
    padding-top: 3rem;
    margin: 0;
  }
`;

export const Buttons = styled.div`
  display: flex;
  @media (max-width: 1200px) {
    width: 100%;
    justify-content: space-between;
  }
`;
